module.exports = __webpack_public_path__ + "static/media/ikon_fyrlykt_selected.73f9115d.svg";